<div description withLoadingSkeleton [isLoading]="!productDescription()">
  {{ productDescription() }}
</div>
